/**
 * Helpers client pour callables Firebase (timeout + App Check).
 * Évite les spinners infinis quand reCAPTCHA / WebView bloque App Check.
 */
import { getToken } from 'firebase/app-check';
import { appCheck } from '../firebase/config';

export function withTimeout(promise, ms, message) {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => {
      reject(new Error(message || `Délai dépassé (${Math.round(ms / 1000)}s)`));
    }, ms);
  });
  return Promise.race([promise, timeout]).finally(() => {
    if (timer) clearTimeout(timer);
  });
}

/**
 * Prépare un token App Check avec délai max (ne bloque pas indéfiniment).
 * Le SDK callable enverra aussi le token s’il est prêt.
 */
export async function warmAppCheckToken(timeoutMs = 8000) {
  if (!appCheck) return null;
  try {
    const result = await withTimeout(
      getToken(appCheck, /* forceRefresh */ false),
      timeoutMs,
      'App Check timeout'
    );
    return result?.token || null;
  } catch (err) {
    console.warn('[appCheck] warm token:', err?.message || err);
    return null;
  }
}

export function callableErrorMessage(err, fallback = 'Erreur réseau') {
  if (!err) return fallback;
  const code = err.code || '';
  const raw = String(err.message || fallback);
  if (code === 'functions/failed-precondition' && /app check/i.test(raw)) {
    return 'Sécurité App Check indisponible. Rouvrez le lien dans Chrome ou Safari (pas l’aperçu mail).';
  }
  return raw
    .replace(/^Firebase:\s*/i, '')
    .replace(/\s*\([^)]*\)\s*$/, '')
    .trim() || fallback;
}
